import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import VuetifyToast from 'vuetify-toast-snackbar';
import router from '@/router';
import vuetify from '@/plugins/vuetify';
import VuetifyTelField from '@/modules/VuetifyTelField';
import App from '@/App.vue';
import i18n from './modules/i18n';
import store from './modules/store';
import { capitalize, formatDateLocaleDateString, spacedPhoneNumber, maskPhone } from '@/filters';
import '@/sass/app.scss';

export { i18n };
import './modules/plugins';
import './modules/globalComponents';

import * as Sentry from "@sentry/vue";
import environment from "@/environment";
import {
  authUserService,
  INACTIVE_USER_TIME_THRESHOLD_IN_MILLISECONDS,
  INACTIVE_USER_TIME_THRESHOLD_IN_MINUTES
} from "@/services/auth-user";
import {baseNameRoutes} from "@/router/paths";

sync(store, router);

Vue.use(VuetifyTelField, {
  vuetify,
});

Vue.use(VuetifyToast, {
  $vuetify: vuetify.framework,
  x: 'left',
  y: 'bottom',
  color: 'info',
  icon: false,
  timeout: 6000,
  dismissable: true,
  autoHeight: false,
  multiLine: false,
  vertical: false,
  shorts: {
    custom: {
      color: 'purple',
    },
  },
  property: '$toast',
});

Vue.use(require('vue-shortkey'));

[capitalize, formatDateLocaleDateString, spacedPhoneNumber, maskPhone].forEach(filter => {
  Vue.filter(filter.name, filter);
});

Vue.config.productionTip = false;

function loadSentry() {
  if (environment.sentry) {
    Sentry.init({
      Vue,
      dsn: environment.sentry.dsn,
      integrations: [
        new Sentry.BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        }),
        new Sentry.Replay(),
      ],
      tracesSampleRate: 1.0,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  }
}

loadSentry();

const loadVueWithOidcIntegration = async function() {
  const { oidcEarlyInit } = await import("oidc-spa/entrypoint");
  const OidcPlugin = (await import('@/plugins/oidc/oidc-plugin')).default;

  const { shouldLoadApp } = oidcEarlyInit({
    safeMode: false,
    BASE_URL: "/"
  });

  if (!shouldLoadApp) {
    return;
  }

  await Vue.use(OidcPlugin, {
    issuerUri: environment.keycloakConfig.url + '/realms/' + environment.keycloakConfig.realm,
    clientId: environment.keycloakConfig.clientId,
    store,
    router,
    onReady: () => {
      window.vm = new Vue({
        store,
        i18n,
        vuetify,
        router,
        render: h => h(App),
      }).$mount('#app');
    }
  });
}

if (environment.isKeycloakIntegration) {
  loadVueWithOidcIntegration();
} else {
  window.vm = new Vue({
    store,
    i18n,
    vuetify,
    router,
    render: h => h(App),
  }).$mount('#app');
}
